<template>

    <base-radio-group
        :item-list="buildPdfLanguageListForRadioSelector"
        :selected-value="selectedPdfLanguage"
        value-key="languageKey"
        label-key="languageName"
        @onChangeValue="selectedPdfLanguage = $event.newValue"
        :hide-details="true"
    ></base-radio-group>

</template>

<script>

import {mapGetters} from "vuex";
import BaseRadioGroup from "../BaseRadioGroup";

export default {
    name: "PdfTranslateLanguageSelectorRadioGroup",
    components: {BaseRadioGroup},
    props: [
        'selectedLanguage',
        'languageList'
    ],

    computed: {
        ...mapGetters({
            getAppPropertyValueArray: 'TranslationStore/getAppPropertyValueArray'
        }),

        selectedPdfLanguage: {
            get() {
                return this.selectedLanguage;
            },
            set(newValue) {
                this.$emit('onChangeSelectedPdfLanguage', {selectedPdfLanguage: newValue});
            },
        },

        findLanguageNameForDisplay() {
            return (langKey) => {
                return (this.text('api.language.name.' + langKey).length > 0)
                    ? this.text('api.language.name.' + langKey.toLowerCase() )
                    : langKey;
            };
        },

        buildPdfLanguageListForRadioSelector() {
            return this.languageList.map((languageKey) => {
                return {
                    languageKey: languageKey,
                    languageName: this.findLanguageNameForDisplay(languageKey)
                };
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/shared/assessment-share/PdfTranslateLanguageSelectorRadioGroup.vue